import { SVGProps } from './types';

const InProgressTimelineIndicator = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#57524D"
      d="M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10"
    ></path>
    <circle cx="10" cy="10" r="3.333" fill="#fff"></circle>
  </svg>
);

export { InProgressTimelineIndicator };
